import { useDroppable } from "@dnd-kit/core"
import { cn } from "design-system/utils"
import { ClusterSnapshotDataSchema } from "schema"
import { z } from "zod"
import { ClusterSnapshotItem } from "./ClusterSnapshotItem"

type ClusterSnapshot = z.infer<typeof ClusterSnapshotDataSchema>

type Props = {
  snapshots: ClusterSnapshot[]
  topicId: string
}

export const ClusterSnapshotList = ({ snapshots, topicId }: Props) => {
  const { setNodeRef, isOver } = useDroppable({
    id: topicId,
  })

  const hasSnapshots = snapshots.length > 0

  return (
    <div
      ref={setNodeRef}
      className={cn(
        "flex h-full min-h-[200px] flex-col rounded border border-transparent transition-all duration-200",
        isOver && "border-primary/60 bg-primary/5 shadow-sm",
        !hasSnapshots && "items-center justify-center text-sm text-muted-foreground",
      )}
    >
      {!!snapshots.length && (
        <div className="flex flex-col gap-3 py-4">
          {snapshots.map((snapshot) => (
            <ClusterSnapshotItem key={snapshot.id} snapshot={snapshot} />
          ))}
        </div>
      )}
    </div>
  )
}
